<script setup>
import { ref } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const currentPath = ref(route.fullPath);
const basePath = currentPath.value.split('/environment')[0];
</script>

<template>
  <div class="flex w-full items-center justify-center border-b bg-white">
    <a href="#" class="tab">Scene</a>

    <router-link v-slot="{ href, isExactActive }" :to="`${basePath}/environment/camera`" :replace="true" custom>
      <a :href="href" :class="{ activeTab: isExactActive }" class="tab" @click.prevent="navigate">Camera</a>
    </router-link>

    <a href="#" class="tab">Lighting</a>

    <a href="#" class="tab">Post Processing</a>
  </div>
</template>

<style lang="postcss" scoped>
.tab {
  @apply flex h-10 items-center bg-transparent px-6 py-2 text-center text-xs uppercase tracking-wider text-gray-600;
  @apply border-b-2 border-transparent font-semibold;
}
.tab:hover {
  @apply hover:border-gray-400;
}
.activeTab {
  @apply border-b border-brand-500 text-brand-500;
}
</style>
